import React from 'react';
import FooterForm from './form';
import { notification } from 'antd';
import history from '../../modules/History';
import { addFooterBanner } from '../../modules/Api';

class AddFooterBanner extends React.Component {
    constructor() {
        super();
        this.state = {
            submitted: false,
            data: {}
        }
    }
    submit(values) {
        if (this.state.submitted) {
            return;
        }

        this.setState({ submitted: true });
        const formData = values;
        addFooterBanner(formData, (res) => {
            this.setState({ submitted: false });
            console.log(res, res.status);
            if (res.status && res.status == 'ok') {
                notification.open({
                    message: `بنر با موفقیت اضافه شد!`,
                    description: ``
                });
                history.item.push(`/footer-banner`);
            }
            else {
                notification.open({
                    message: 'خطایی رخ داده است.',
                    description: res.message
                });
            }
        });
    }
    render() {
        return (<div><FooterForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted} /></div>);
    }
}

export default AddFooterBanner;


// WEBPACK FOOTER //
// ./src/containers/FooterBanner/add.js